function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { getCookie } from '@ali/arise-h5-utils-cookie';
import getEnv, { isDaily, isPre, getEntrance, isInAriseApp, isAndroid, isIos } from '@ali/arise-h5-utils-env';
import jsonp from '@ali/arise-h5-utils-jsonp';
import domain from './domain.js';
import formatMtopRet from './ret.js';
var NEED_LOGIN_RESPONSE = ['SESSION_EXPIRED', 'SID_INVALID', 'AUTH_REJECT', 'NEED_LOGIN'];
var RESPONSE_TYPE = {
  /**
   * @description 请求出错
   * @type {Number}
   */
  ERROR: -1,
  /**
   * @description 请求成功
   * @type {Number}
   */
  SUCCESS: 0,
  /**
   * @description 请求token过期
   * @type {Number}
   */
  TOKEN_EXPIRED: 1,
  /**
   * @description 请求session过期
   * @type {Number}
   */
  SESSION_EXPIRED: 2
};
var _getEnv = getEnv(false),
  regionID = _getEnv.regionID,
  language = _getEnv.language;
var getAppKey = function () {
  return isDaily() ? '4272' : '24677475';
};
var getDefaultDomain = function () {
  if (isDaily()) {
    return domain.DAILY;
  } else if (isPre()) {
    return domain.PRE[regionID];
  } else {
    return domain.PROD[regionID];
  }
};
var defaultDomain = getDefaultDomain();
var configDomain = {};
var customizeLoginUrl = null;
var getSecurityHeaderParams = function (OnlyHost) {
  // https://yuque.antfin-inc.com/lzd-fe-sz/trade/owxqa4
  var result = {};
  if (window.umidTokenFromHeader) {
    // new version to get umidtoken and UA
    result = {
      'x-ua': window.uabModule && window.uabModule.getUA ? window.uabModule.getUA({
        OnlyHost: OnlyHost
      }) : window.UAFromHeader,
      'x-umidtoken': window.umidTokenFromHeader
    };
  } else if (window.Group_umid && window.Group_umid.getUA && window.Group_umid.getUmidToken) {
    // old version to get umidtoken and UA
    result = {
      'x-ua': window.Group_umid.getUA(),
      'x-umidtoken': window.Group_umid.getUmidToken()
    };
  }
  return result;
};
var getFormatSecHeader = function (params) {
  var result = {};
  if (params.isSec === 1 && window.fyModule) {
    // new version to get umidtoken and UA
    result = {
      'x-ua': fyModule.getFYToken ? fyModule.getFYToken() : '',
      'x-umidtoken': fyModule.getUidToken ? fyModule.getUidToken() : ''
    };
  }
  return result;
};
var getAlipaySecurityHeader = function () {
  var result = {};
  // only in pc or msite need to add header App has done
  if (!isInAriseApp() && localStorage) {
    var aliPaySecurityToken = localStorage.getItem('_alipay_security_token_');
    if (aliPaySecurityToken) {
      result = {
        'x-apdid-token': aliPaySecurityToken
      };
    }
  }
  return result;
};

/**
 * check ret is include the login tag
 * @param {*} ret
 */
function needLogin(ret) {
  if (ret === void 0) {
    ret = '';
  }
  if (typeof ret !== 'string') {
    ret = JSON.stringify(ret);
  }
  for (var i in NEED_LOGIN_RESPONSE) {
    if (ret.indexOf(NEED_LOGIN_RESPONSE[i]) !== -1) {
      return true;
    }
  }
  return false;
}

// TODO: Add more domains when everything is determined.
function getLoginUrl() {
  var preLoginUrlMap = {
    ES: location.hostname + "/member/sign-up",
    FR: location.hostname + "/member/sign-up"
  };
  var productionLoginUrlMap = {
    ES: location.hostname + "/member/sign-up",
    FR: location.hostname + "/member/sign-up"
  };
  if (isDaily()) {
    return {
      ES: 'pre-www.miravia.es/member/sign-up',
      FR: 'pre-www.miravia.es/member/sign-up'
    }[regionID] || '';
  }
  if (isPre()) {
    return preLoginUrlMap[regionID] || '';
  }
  return productionLoginUrlMap[regionID] || '';
}
function gotoLogin(lzdExtraParams, successCallback, failCallback) {
  if (lzdExtraParams === void 0) {
    lzdExtraParams = {};
  }
  var redirect = window.location.href;
  if (isInAriseApp()) {
    window && window.WindVane && window.WindVane.call('LAWVUserInfo', 'login', {}, function (res) {
      return successCallback && successCallback(res);
    }, function () {
      if (failCallback) {
        failCallback({
          errorCode: {
            displayMessage: 'Sorry, you have not login'
          }
        });
      }
    });
  } else if (isAndroid() || isIos()) {
    var url = '';
    if (customizeLoginUrl) {
      url = "//" + customizeLoginUrl + "#redirect=" + encodeURIComponent(redirect);
      window.location = url;
    } else {
      if (window.jsapi && window.jsapi && window.jsapi.login) {
        window.jsapi.login.open({
          ismtop: true
        });
      }
    }
  } else {
    if (window.jsapi && window.jsapi && window.jsapi.login) {
      window.jsapi.login.open({
        ismtop: true
      });
    }
  }
}

// TODO: Use arise later when everything is determined.
export function domainConfig() {
  var _Object$assign = Object.assign({
      prefix: '',
      subDomain: 'acs-m',
      mainDomain: 'lazada.com'
    }, defaultDomain, configDomain),
    prefix = _Object$assign.prefix,
    subDomain = _Object$assign.subDomain,
    mainDomain = _Object$assign.mainDomain;
  lib.mtop.config.prefix = prefix;
  lib.mtop.config.subDomain = subDomain;
  lib.mtop.config.mainDomain = mainDomain;
  // fix lib-mtop getmainDomain issue: https://yuque.antfin.com/mtbsdkdocs/mtopjssdkdocs/uyq37p
  lib.mtop.config.pageDomain = mainDomain;
}

/**
 * got bottom data when mtop request is failed
 * @param {*} mtopAppId icms appid
 * @param {*} successCallback success callback
 * @param {*} failureCallback fail callback
 */
function fetchBottomData(mtopAppId, successCallback, failureCallback) {
  new Date().getTime();
  var callbackMtopAppId = mtopAppId.replace(/-/g, '_');
  var mtopAppIdOnUrl = mtopAppId.replace(/,/g, '/');
  jsonp("//overseas-aladdin.alicdn.com/bottom/" + mtopAppIdOnUrl + "/language=" + language + "/regionID=" + regionID + "/data.jsonp", {
    jsonpCallbackFunctionName: "callback_" + callbackMtopAppId + "_language_" + language + "_regionID_" + regionID
  }).then(function (res) {
    new Date().getTime();
    successCallback(res.json());
  }).catch(function (e) {
    new Date().getTime();
    failureCallback(e);
  });
}
function requestByH5Mtop(params, successCallback, failureCallback) {
  var isIcmsMtop = params.isIcmsMtop || 0;
  var mtopAppId = params.data && params.data.appId || params.api;
  var isbackup = params.data && params.data.isbackup || '';
  new Date().getTime();
  return lib.mtop.request(params, function (res) {
    new Date().getTime();
    var ret = res && res.ret && res.ret.length && res.ret[0].split('::');
    if (res && res.ret && res.ret.length && res.ret[0] === 'WV_ERR::PARAM_PARSE_ERROR') {
      // 修复U4上安卓4.4下 WV_ERR::PARAM_PARSE_ERROR 错误问题
      lib.mtop.H5Request(params, successCallback, failureCallback); // eslint-disable-line
    } else if (ret[0] === 'SUCCESS' && res.data) {
      if (isIcmsMtop && res.data.resultValue && res.data.resultValue[mtopAppId]) {
        // 判断是否是需要走打底数据
        if (res.data.resultValue[mtopAppId].success !== 'false' || !res.data.resultValue[mtopAppId].success) {
          successCallback(res.data.resultValue[mtopAppId]);
        } else if (isbackup) {
          fetchBottomData(mtopAppId, successCallback, failureCallback);
        } else {
          successCallback(res.data.resultValue[mtopAppId]);
        }
      } else {
        successCallback(res);
      }
    } else {
      if (isIcmsMtop && isbackup) {
        fetchBottomData(mtopAppId, successCallback, failureCallback);
      } else {
        res.errorCode = formatMtopRet(res.ret);
        failureCallback(res);
      }
    }
  }, function (e) {
    if (isIcmsMtop && isbackup) {
      fetchBottomData(mtopAppId, successCallback, failureCallback);
    } else {
      e.errorCode = formatMtopRet(e.ret);
      failureCallback(e);
    }
    new Date().getTime();
  });
}
var inDev = process.env.NODE_ENV === 'development';
var request = function (params, successCallback, failureCallback) {
  var lzdExtraParams = params.lzdExtraParams;
  delete params.lzdExtraParams;
  var _params = params,
    _params$mock = _params.mock,
    mock = _params$mock === void 0 ? {} : _params$mock,
    _params$ignoredHeader = _params.ignoredHeaders,
    ignoredHeaders = _params$ignoredHeader === void 0 ? [] : _params$ignoredHeader;
  if (inDev && mock.useMock && mock.tag) {
    var baseUrl = mock.baseUrl || 'https://oneapi.alibaba-inc.com/mock';
    return fetch(baseUrl + "/" + mock.tag + "/" + params.api, {
      mode: 'cors',
      method: params.method || 'get'
    }).then(function (res) {
      return res.json();
    });
  } else {
    delete params.mock;
  }
  params.data = params.data || {};

  // lib-mtop script version mast higher than 2.4.11
  var additionalHeaders = {
    'x-i18n-language': language,
    // compatible mtop rules
    'x-i18n-regionID': regionID,
    // compatible mtop rules
    entrance: getEntrance()
  };
  params = Object.assign({}, {
    api: '',
    v: '1.0',
    ecode: 0,
    type: 'GET',
    isSec: 1,
    // will generate `ua` on web, `wua` in APP
    AntiCreep: true,
    // for Baxia, https://yuque.antfin-inc.com/mtbsdkdocs/mtopjssdkdocs/gtqlxc
    timeout: 20000,
    needLogin: false,
    appKey: getAppKey(),
    dataType: 'json',
    sessionOption: 'AutoLoginOnly' // 后置的登录强制不拉起，直接由前端发起的
  }, additionalHeaders, params);

  // TODO: add x-uid to headers
  var uid = getCookie('lzd_uid');
  if (uid) {
    additionalHeaders['x-uid'] = uid;
  }
  var securityHeaderParams = getSecurityHeaderParams(params.shortUa ? 1 : 0);

  // update baxia sdk
  var formatSecHeader = getFormatSecHeader(params);

  // get alipay security header
  var alipaySecHeader = getAlipaySecurityHeader();
  params.ext_headers = Object.assign(params.ext_headers || {}, additionalHeaders, securityHeaderParams, formatSecHeader, alipaySecHeader);
  ignoredHeaders.forEach(function (ik) {
    return delete params.ext_headers[ik];
  });
  if (params.api.length === 0) {
    console.error('api can not be empty');
    return;
  }
  if (!Promise) {
    var error = '当前浏览器不支持Promise,请在windows对象上挂载Promise对象,可参考（http://gitlab.alibaba-inc.com/mtb/lib-es6polyfill/tree/master）中的解决方案';
    lib.mtop = {
      ERROR: error
    };
    throw new Error(error);
  }
  return new Promise(function (resolve, reject) {
    var _successCallback = function _successCallback(res) {
      if (successCallback) {
        successCallback(res);
      } else {
        resolve(res);
      }
    };
    var _failCallbackWithoutLogin = function _failCallbackWithoutLogin(err) {
      console.warn("UAT mtop error log:" + JSON.stringify(err));
      if (failureCallback) {
        failureCallback(err);
      } else {
        reject(err);
      }
    };
    var _failCallback = function _failCallback(retJson) {
      var ret = retJson.ret;
      if (needLogin(ret) && params.needLogin === true) {
        gotoLogin(lzdExtraParams, function () {
          return requestByH5Mtop(params, _successCallback, _failCallbackWithoutLogin);
        }, _failCallbackWithoutLogin);
      } else {
        return _failCallbackWithoutLogin(retJson);
      }
    };
    if (typeof lib !== 'undefined' && lib.mtop) {
      domainConfig();
      return requestByH5Mtop(params, _successCallback, _failCallback);
    }
    _failCallbackWithoutLogin('lib is not defined, please check out lib-mtop.js has been loaded');
  });
};
export default {
  request: request,
  config: function config(k, v) {
    if (typeof lib !== 'undefined' && lib.mtop) {
      if (typeof k === 'string') {
        configDomain[k] = v;
        lib.mtop.config[k] = v; // 调用就直接注册
      } else {
        configDomain = _extends({}, lib.mtop.config, k);
        lib.mtop.config = _extends({}, lib.mtop.config, k); // 调用就直接注册
      }
    }
  },
  setDomain: function setDomain(domain) {
    Object.assign(configDomain, domain);
  },
  RESPONSE_TYPE: RESPONSE_TYPE,
  setLoginUrl: function setLoginUrl(url) {
    customizeLoginUrl = url;
  }
};